export const getMainWrapper = () => document.querySelector('.main-wrapper')

export const ensureSidebarOverlay = () => {
    let overlay = document.querySelector('.sidebar-overlay')
    if (!overlay) {
        overlay = document.createElement('div')
        overlay.className = 'sidebar-overlay'
        document.body.appendChild(overlay)
    }
    return overlay
}

export const openMobileSidebar = () => {
    getMainWrapper()?.classList.add('slide-nav')
    ensureSidebarOverlay().classList.add('opened')
    document.documentElement.classList.add('menu-opened')
}

export const closeMobileSidebar = () => {
    getMainWrapper()?.classList.remove('slide-nav')
    document.querySelector('.sidebar-overlay')?.classList.remove('opened')
    document.documentElement.classList.remove('menu-opened')
}

export const toggleMobileSidebar = () => {
    const wrapper = getMainWrapper()
    if (wrapper?.classList.contains('slide-nav')) {
        closeMobileSidebar()
    } else {
        openMobileSidebar()
    }
}

export const toggleMiniSidebar = () => {
    document.body.classList.toggle('mini-sidebar')
}

export const getTheme = () =>
    document.documentElement.getAttribute('data-bs-theme') || 'light'

export const toggleTheme = () => {
    const html = document.documentElement
    const next = getTheme() === 'light' ? 'dark' : 'light'
    html.setAttribute('data-bs-theme', next)
    if (window.config) {
        window.config.theme = next
    }
    return next
}

export const toggleFullscreen = () => {
    const elem = document.documentElement
    if (!document.fullscreenElement) {
        elem.requestFullscreen?.()
    } else {
        document.exitFullscreen?.()
    }
}

export const isFullscreen = () => Boolean(document.fullscreenElement)
